<template lang="pug">
.dawn-card
  .dawn-card-top
    slot(name='top')
    span.close-icon(v-if='!hasSlotTop')
      i.fal.fa-times(v-if='removable' @click='removecard')
  .dawn-card-header
    span.dawn-card-header-icon(v-if='icon')
      i(:class='iconClass')
    span.dawn-card-header-title
      p.title
        slot(name='title')
        span.title-text(v-if='!hasSlotTitle' @click='edit' v-tooltip="titleTooltip") {{ title }}
        slot(name='title-icon')
      p.subtitle(v-if='subtitle') {{ subtitle }}
  .dawn-card-body
    slot(name='body')
  .dawn-card-footer.text-right-
    slot(name='footer')
    div(v-if='!hasSlotFooter')
      ed-button(button-class='btn btn-actionbar', @click='edit', v-if='footerButton != "false" && !href') {{ footerButton }}
      ed-button(button-class='btn btn-actionbar', @click='edit', v-if='footerButton != "false" && !!href' :href='href') {{ footerButton }}
  div(:class='{ "dawn-card-help-mask": $slots.mask }')
    slot(name='mask')
  .dawn-card-tag {{ $t('New') }}
</template>

<script>
export default {
  name: 'ed-card',
  props: {
    id: {
      type: Number,
      default: 1
    },
    title: {
      type: String
    },
    titleTooltip: {
      type: String
    },
    subtitle: String,
    footerButton: {
      type: String,
      default: 'Edit'
    },
    icon: Array,
    href: String,
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSlotTop () {
      return this.$slots.top
    },
    hasSlotTitle () {
      return this.$slots.title
    },
    hasSlotFooter () {
      return this.$slots.footer
    },
    iconClass () {
      return this.icon[0] + ' fa-' + this.icon[1]
    }
  },
  methods: {
    removecard: function () {
      var id = this.id
      this.$emit('removecard', id)
    },
    edit: function () {
      var id = this.id
      this.$emit('edit', id)
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-card {
  float: left;
  width: 280px;
  min-height: 10rem;
  margin: 0rem 1.5rem 1.5rem 0rem;
  padding: .75rem .65rem .0rem .65rem;
  box-shadow: $box-shadow;
  @include theme {
  background-color: v(canvas);
  border-color: v(background);
  }
  transition: all .3s ease;
  position: relative;

  .icon + .title-text {
    cursor: pointer;
  }

  .dawn-card-tag {
    display: none;

    font-size: 10px;
    text-transform: uppercase;
    @include theme {
    background: v(tertiary-01);
    color: v(canvas);
    }
    padding: 1px 8px 0;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  &.new {
    @include theme {
    border-color: v(tertiary-01);
    }
    border-width: 2px;
    border-style: solid;
    position: relative;

    .dawn-card-top {
      margin-top: -2px;
    }
    .dawn-card-tag {
      display: inline-block;

    }
  }

  p.title {
    font-weight: $font-weight-bold;
    font-size: $font-size-base;
    @include theme { color: v(primary-05) }
    margin-bottom: .5em;
  }

  p.subtitle {
    font-size: $font-size-xsmall;
    line-height: 1.2;
    min-height: 2.5rem;
  }

  .dawn-card-header {
    display: flex;
    flex-direction: row;
    -webkit-flex-direction: row;
  }

  .dawn-card-header-icon {
    display: inline-block;
    font-size: 1.5rem;
    @include theme { color: v(ink) }
    padding: 0rem .5rem 0rem 0rem;

    i {
      vertical-align: top;
    }
  }

  .dawn-card-header-title {
    display: inline-block;
  }
}

.dawn-card-top {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -20px;
  min-height: 30px;

  span.close-icon {
    min-height: 24px;

    font-weight: 100;
    @include theme { color: v(ink) }
    margin-left: 2rem;
    &:hover {
      cursor: pointer;
    }
  }

  .form-group {
    margin-bottom: -5px;
  }
}

.dawn-card-body p {
  font-size: $font-size-medium;
  margin-bottom: 0;
}

.dawn-card-enter {
  opacity: 0;
}

.dawn-card-leave-active {
  opacity: 0;
}

.dawn-card-enter .dawn-card-container,
.dawn-card-leave-active .dawn-card-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.dawn-card-help-mask {
  visibility: hidden;
  font-size: $font-size-xsmall;
  padding: .75rem .65rem .0rem .65rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @include theme {
  background-color: v(canvas);
  color: v(ink);
  }
  opacity: 0;
  transition: all .6s ease;
}
.dawn-card-footer:hover + .dawn-card-help-mask {
  visibility: visible;
  opacity: .95;
  z-index: 1;
}

.dawn-card-footer {
  position: relative;
  z-index: 2;
  min-height: 3.3rem;
  .btn {
    text-decoration: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edCard/index.vue